<div id="statut-preautorisation-acceptee" class="statut-preautorisation-acceptee">
  <div *ngIf="isPreautExpiringSoon$ | async">
    <div class="status-box-expiration-preaut-container">
      <app-status-box-clock
        [textContent]="
          'dashboard.active-preaut.accepte.expiration-preaut-statut'
            | translate: { dateExpirationPreaut: lastDayBeforeExpirationPreautEnLigne$ | async | date: langue }
        "
      ></app-status-box-clock>
    </div>
    <div class="expiration-preaut-text">
      {{ 'dashboard.active-preaut.accepte.expiration-preaut-text' | translate }}
    </div>
  </div>

  <div
    *ngIf="(isRateExpiringSoon$ | async) && !(isPreautExpiringSoon$ | async)"
    class="status-box-expiration-taux-container"
  >
    <app-status-box-clock
      [textContent]="
        'dashboard.active-preaut.accepte.expiration-taux'
          | translate: { dateExpirationTaux: dateExpirationTaux$ | async | date: langue }
      "
    ></app-status-box-clock>
  </div>

  <div *ngIf="!(isPreautExpiringSoon$ | async) && !(isRateExpiringSoon$ | async)" class="status-box-success-container">
    <app-status-box-success
      [textContent]="
        'dashboard.active-preaut.accepte.titre' + ((isCoemprunteur$ | async) ? '-coemprunteur' : '')
          | translate: { nomMembre: nomMembre }
      "
    ></app-status-box-success>
  </div>

  <div class="text">
    <div class="montant-preautorise">
      <strong [innerHTML]="'dashboard.active-preaut.accepte.montant' | translate"></strong>
      <strong class="montant">
        <app-currency-string [value]="preautAmount$ | async" [id]="'montant-preautorise'"></app-currency-string>
      </strong>
    </div>

    <div
      *ngIf="(isRateExpiringSoon$ | async) && !(isPreautExpiringSoon$ | async)"
      id="date-expiration-preautorisation"
      class="date-expiration-preaut-avec-taux"
      [innerHTML]="
        'dashboard.active-preaut.accepte.date-expiration-preaut-avec-taux'
          | translate: { dateExpirationPreaut: lastDayBeforeExpirationPreautEnLigne$ | async | date: langue }
      "
    ></div>

    <div
      *ngIf="!(isRateExpiringSoon$ | async) && !(isPreautExpiringSoon$ | async)"
      id="date-expiration-preautorisation"
      class="date-expiration-preaut-sans-taux"
      [innerHTML]="
        'dashboard.active-preaut.accepte.date-expiration-preaut-sans-taux'
          | translate: { dateValide: lastDayBeforeExpirationPreautEnLigne$ | async | date: langue }
      "
    ></div>

    <div *ngIf="(isPreautExpiringSoon$ | async) || (isRateExpiringSoon$ | async)" class="si-vous-avez-des-questions">
      <span>{{ 'dashboard.active-preaut.accepte.si-vous-avez-des-questions' | translate }}</span>
      <app-boite-contact
        buttonStyle="textOnly"
        [buttonText]="'dashboard.active-preaut.accepte.lien'"
      ></app-boite-contact>
    </div>
  </div>

  <button
    mat-button
    id="btn-preaut-en-ligne-acceptee-details"
    class="green little voir-detail full-width-xs compact-height-button"
    [class.white]="!isDefaultBtnColor"
    [routerLink]="'/preautorisation-simplifiee/acceptee'"
  >
    {{ 'dashboard.active-preaut.btn-details' | translate }}
  </button>
  <span class="annuler-demande-preaut">
    {{ 'dashboard.active-preaut.situation' | translate }}
    <button
      appDisabledIfConseiller
      class="text-only-button"
      id="btn-annuler-preautorisation"
      (click)="openCancelModal()"
    >
      {{ 'dashboard.active-preaut.btn-annuler-preaut-acceptee' | translate }}
    </button>
  </span>
</div>
